import React from "react";
import { NavigateFunction } from "react-router-dom";
import ItemsIcon from "../../../../../images/common/item-grey.svg";
import TrioBallsIcon from "../../../../../images/common/ball-trio.svg";
import ServiceIcon from "../../../../../images/common/service.svg";
import ProductIcon from "../../../../../images/common/product.svg";
import DonationIcon from "../../../../../images/donation/donating-hands.svg";
import { CountryWithStateModel, RelatedItemsGridModel } from "../models";
import { SystemItemTypes } from "../enums";
import {
  ITableHeaders,
  TableWithHeaderButtons,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import PlaceholderSmallerGrid from "./PlaceholderSmallerGrid";
import TableGrid from "./TableGrid";

type IProps = {
  navigate: NavigateFunction;
  items: RelatedItemsGridModel[];
  countriesWithState: CountryWithStateModel[];
};
const RelatedItemsGrid: React.FC<IProps> = ({ items, countriesWithState }) => {
  const getIcon = (type: keyof typeof SystemItemTypes) => {
    switch (type) {
      case SystemItemTypes.Product:
        return <img src={ProductIcon} style={{ height: "20px" }} />;
      case SystemItemTypes.Membership:
        return <img src={TrioBallsIcon} style={{ height: "20px" }} />;
      case SystemItemTypes.Service:
        return <img src={ServiceIcon} style={{ height: "20px" }} />;
      case SystemItemTypes.Donation:
        return <img src={DonationIcon} style={{ height: "20px" }} />;
      default:
        return null;
    }
  };

  const headers = () => {
    const columns: ITableHeaders<RelatedItemsGridModel>[] = [
      {
        dataKey: "type",
        title: "Type",
        onCellRender: (data: RelatedItemsGridModel) => {
          return getIcon(data.type);
        },
      },
      {
        dataKey: "name",
        title: "Name",
        onCellRender: (data: RelatedItemsGridModel) => {
          return data.name;
        },
      },
      {
        dataKey: "priceOrvariant",
        title: "Price / Variant",
        onCellRender: (data: RelatedItemsGridModel) => {
          return data.priceOrvariant;
        },
      },
      {
        dataKey: "oneTimePrice",
        title: "One Time Price",
        onCellRender: (data: RelatedItemsGridModel) => {
          return data.oneTimePrice;
        },
      },
      {
        dataKey: "recurringPrice",
        title: "Recurring Price",
        onCellRender: (data: RelatedItemsGridModel) => {
          return data.recurringPrice;
        },
      },
    ];
    return columns;
  };

  if (items.length == 0)
    return (
      <PlaceholderSmallerGrid
        title="No Items"
        icon={ItemsIcon}
        buttonCaption="New"
        disableButton={true}
      />
    );

  return (
    <TableGrid
      wrapperClassName="table-with-header-btns"
      tableHeader={
        <TableWithHeaderButtons
          isShowHeaderButton={false}
          totalItems={items.length}
          icon={ItemsIcon}
          title="Items"
        />
      }
      cellSpacing={20}
      headers={headers()}
      data={items}
      totalItemCount={items.length}
      countriesWithState={countriesWithState}
    />
  );
};

export default withRouter(RelatedItemsGrid);
